export const PRONTUARIO_SECTIONS = [
	"complaint_expectations",
	"medical_history",
	"surgeries_anesthesia",
	"allergies",
	"medications",
	"habits",
	"gyneco_obstetric",
	"family_history",
	"anthropometry",
	"physical_exam",
	"risk",
	"plan_conduct",
] as const;

export const EXTRACTION_MILESTONE_TYPES = [
	"exam",
	"prescription",
	"surgery",
	"return",
	"intercurrence",
	"measurement",
	"referral",
] as const;

export const ITEM_STATES = ["present", "denied"] as const;

export const ITEM_ORIGINS = ["ia", "dra", "team"] as const;

export type ProntuarioSection = (typeof PRONTUARIO_SECTIONS)[number];

export type ItemState = (typeof ITEM_STATES)[number] | "absent";

export const RELANCE_ITEMS: { key: string; sources: { section: string; keys: RegExp }[] }[] = [
	{ key: "smoking", sources: [{ section: "habits", keys: /^(smoking|vape)/u }] },
	{
		key: "tev_risk",
		sources: [
			{ section: "medical_history", keys: /^(tev|thrombophilia|varices)$/u },
			{ section: "family_history", keys: /^tev_family$/u },
			{ section: "medications", keys: /^estrogen:/u },
		],
	},
	{ key: "allergies", sources: [{ section: "allergies", keys: /./u }] },
	{
		key: "bleeding_medication",
		sources: [{ section: "medications", keys: /^(anticoagulant|antiplatelet|phytotherapic):/u }],
	},
	{ key: "glp1", sources: [{ section: "medications", keys: /^glp1:/u }] },
	{ key: "isotretinoin", sources: [{ section: "medications", keys: /^isotretinoin:/u }] },
	{
		key: "dm_has_apnea",
		sources: [{ section: "medical_history", keys: /^(dm|has|apnea)$/u }],
	},
	{
		key: "bmi_weight_bariatric",
		sources: [
			{ section: "anthropometry", keys: /^(bmi|weight):/u },
			{ section: "surgeries_anesthesia", keys: /^bariatric/u },
		],
	},
	{
		key: "anesthetic_complication",
		sources: [
			{ section: "surgeries_anesthesia", keys: /^anesthetic_complication/u },
			{ section: "family_history", keys: /^anesthetic_complication_family$/u },
		],
	},
	{ key: "asa", sources: [{ section: "risk", keys: /^asa$/u }] },
	{
		key: "mental_health",
		sources: [
			{ section: "medical_history", keys: /^(mental_health|bdd)$/u },
			{ section: "surgeries_anesthesia", keys: /^previous_dissatisfaction/u },
			{ section: "medications", keys: /^psychotropic:/u },
		],
	},
	{
		key: "pregnancy_breastfeeding",
		sources: [{ section: "gyneco_obstetric", keys: /^(pregnancy_plans|breastfeeding)$/u }],
	},
	{
		key: "keloid",
		sources: [
			{ section: "medical_history", keys: /^keloid$/u },
			{ section: "family_history", keys: /^keloid_family$/u },
		],
	},
	{ key: "breast_screening", sources: [{ section: "gyneco_obstetric", keys: /^breast_screening$/u }] },
];
